import { render } from "./AddProfesseurPage.vue?vue&type=template&id=61bbc57b&ts=true"
import script from "./AddProfesseurPage.vue?vue&type=script&lang=ts"
export * from "./AddProfesseurPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__